import React from 'react'
import {Modal, ModalHeader, ModalFooter, Button, ModalBody} from 'reactstrap'

import {trans, getFeature, getFeatures} from '@utils'
import UpgradeContent from "./modules/common/UpgradeContent"

const UnAvailableFeatureModal = (props) => {
  const {featureKey, onClose} = props
  console.log('UnAvailableFeatureModal', featureKey)
  return (
    <Modal
      isOpen={true}
      toggle={onClose}
      unmountOnClose={true}
      backdrop={true}
      className='modal-md modal-dialog-centered'
      modalClassName={''}
    >
      <ModalHeader className={'bg-white'} toggle={onClose}>
        {/*{trans(feature.title)}*/}
      </ModalHeader>
      <ModalBody>
        <UpgradeContent featureKey={featureKey} />
        {/*{*/}
        {/*  React.cloneElement(feature.component, {onClose, ...props})*/}
        {/*}*/}
      </ModalBody>
      {/*<ModalFooter>*/}
      {/*  <Button.Ripple type='button' color='flat-secondary' onClick={onClose}>*/}
      {/*    <span>{trans('gen.actions.cancel')}</span>*/}
      {/*  </Button.Ripple>*/}
      {/*</ModalFooter>*/}
    </Modal>
  )
}
//************************************//
export default UnAvailableFeatureModal
